<template>
    <div id="app">
        <!-- <img src="./assets/logo.png"> -->
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    
};
</script>

<style>
p,
a,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6 {
    margin: 0;
    padding: 0;
    list-style: none;
}
body,
html {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}
#app {
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue